import { firebaseAuth } from '../firebase';

const API_BASE = import.meta.env.VITE_TRANSLATOR_API_BASE_URL;

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

const getAuthToken = async (): Promise<string> => {
  const user = firebaseAuth.currentUser;
  if (user === null) throw new ApiError(401, '未ログイン');
  return await user.getIdToken();
};

export const apiFetch = async <T>(path: string, init?: RequestInit): Promise<T> => {
  const token = await getAuthToken();
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  if (init?.headers !== undefined) {
    Object.assign(headers, init.headers);
  }
  const res = await fetch(`${API_BASE}${path}`, { ...init, headers });
  if (!res.ok) {
    const text = await res.text();
    let message = text;
    try {
      const data = JSON.parse(text) as unknown;
      if (typeof data === 'object' && data !== null && 'message' in data) {
        const m = data.message;
        if (typeof m === 'string') message = m;
      }
    } catch {
      // テキストのまま使う
    }
    throw new ApiError(res.status, message);
  }
  return (await res.json()) as T;
};
